import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {ObjectFactory, UserTrace} from "@commons/types";
import {TurnoDistribuzioneRecord} from "@commons/mapping/TurnoDistribuzioneRecord";
import {merge} from "lodash";
import {WeekdayNumbers} from "luxon/src/datetime";

export type TipoAutomatismoTurnoAlternativo = "MANUALE" | "AUTOMATICO" | "AUTOMATICO_DA_TERMINALE";

export interface TabellaAlternativiTurniRecord extends URIAndTrace {
    idAziendaTabelle: number;
    idTabella: number;
    distribuzione: TurnoDistribuzioneRecord;
    numCoppie: number;
    approsEnt1: number;
    approsEnt2: number;
    approsUsc1: number;
    approsUsc2: number;
    approsEnt3: number;
    approsEnt4: number;
    approsUsc3: number;
    approsUsc4: number;
    automatico: TipoAutomatismoTurnoAlternativo;
    codTerminale: string;
    applicaLUN: boolean;
    applicaMAR: boolean;
    applicaMER: boolean;
    applicaGIO: boolean;
    applicaVEN: boolean;
    applicaSAB: boolean;
    applicaDOM: boolean;
    insertTrace: UserTrace | undefined;
}

export class TabellaAlternativiTurniRecord {
    static factory: ObjectFactory<TabellaAlternativiTurniRecord> = (json?) => {
        return merge<TabellaAlternativiTurniRecord, Partial<TabellaAlternativiTurniRecord> | undefined>({
            idAziendaTabelle: 0,
            idTabella: 0,
            distribuzione: {} as TurnoDistribuzioneRecord,
            numCoppie: 0,
            approsEnt1: 0,
            approsEnt2: 0,
            approsUsc1: 0,
            approsUsc2: 0,
            approsEnt3: 0,
            approsEnt4: 0,
            approsUsc3: 0,
            approsUsc4: 0,
            automatico: 'AUTOMATICO',
            codTerminale: '',
            applicaLUN: true,
            applicaMAR: true,
            applicaMER: true,
            applicaGIO: true,
            applicaVEN: true,
            applicaSAB: true,
            applicaDOM: true,
            insertTrace: undefined,

            URI: null,
        }, json);
    }

    static isAutomatico = (that: TabellaAlternativiTurniRecord, day?: WeekdayNumbers): boolean => {
        switch (that.automatico) {
            case 'MANUALE':
                return false;

            case 'AUTOMATICO':
            case 'AUTOMATICO_DA_TERMINALE':
            default: {
                switch (day) { // in accordo con luxon DataTime weekday, 1 is Monday and 7 is Sunday
                    case 1:
                        return that.applicaLUN;
                    case 2:
                        return that.applicaMAR;
                    case 3:
                        return that.applicaMER;
                    case 4:
                        return that.applicaGIO;
                    case 5:
                        return that.applicaVEN;
                    case 6:
                        return that.applicaSAB;
                    case 7:
                        return that.applicaDOM;
                    default:
                        break;
                }
                return true;
            }
        }
    };
}